import { SCHEMA_V4_STORES } from '~/storage/schema'
import type { BackupPayload } from '../format'
import type { PayloadMigration } from './index'

/**
 * Version 4 — the paired counterpart of the database migration (D-031, D-105).
 *
 * A version-3 backup restored into a version-4 database would otherwise arrive
 * with no `trainingWeeks` store at all, and no upgrade would ever fire to fix
 * it: the live database is already at 4.
 *
 * **The store must appear, even empty.** Validation checks the payload against
 * the current schema, where a **missing store is a gap rather than an empty
 * one** — the same reason `connections` is emitted by the v3 migration and is
 * then always empty in practice.
 *
 * There is nothing else to do here, and the emptiness is the point: the database
 * migration backfills nothing, so a paired migration that invented a week or a
 * schedule would make the two paths disagree in the one direction no test would
 * think to look. The list is derived from `SCHEMA_V4_STORES` rather than naming
 * the store, so a second v4 store cannot be created by the database migration
 * and forgotten here.
 */
export const payloadMigrationV4: PayloadMigration = {
  to: 4,
  describe: 'Add the training-week store',
  migrate(payload: BackupPayload): BackupPayload {
    const empties = Object.fromEntries(SCHEMA_V4_STORES.map((definition) => [definition.name, []]))

    return {
      ...payload,
      stores: {
        ...payload.stores,
        ...empties,
      },
    }
  },
}
